export interface IInputValidator {
    isValidUserName(input: string): boolean;
    isValidEmail(input: string): boolean;
    isValidName(input: string): boolean;
    isValidPassword(input: string): boolean;
}

export class InputValidator implements IInputValidator {
    validator = require("validator");
    isValidUserName(input: string) {
       return /^[a-zA-Z_\d]{3,}$/.test(input.toString());
    }
    isValidEmail(input: string) {
        return this.validator.isEmail(input);
    }
    isValidName(input: string) {
        return /^[a-zA-Z ]*$/.test(input.toString()) && input.length > 3; 
    }
    isValidPassword(input: string) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(input.toString()) ||
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(input.toString());
    }
}


// WEBPACK FOOTER //
// ./src/utility/IInputValidator.ts